module.exports = __webpack_public_path__ + "static/media/check-mark-icon.9b0ce243.png";